import {
   AscSortIcon,
   DateIcon,
   DescSortIcon,
   DownArrow,
   FilterClearIcon,
   ShortIcon,
   UpArrowIcon
} from 'assets'
import { useOutsideClick } from 'Hooks'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import './postReel.css'
import {
   clearInstagramAllSelections,
   getPostListAction,
   resetFetchAllPostStatus,
   resetTotalPostsCount,
   setAllPostDataAction,
   setInstagramBatchAnalysisStatus,
   setInstagramPageNumberAction
} from 'store/action/instagramDashboard'
import { Loader, PostCard } from 'components'
import { errorMessage, instagramPostType, videStatusConst } from 'constant/const'
import InPostsCard from '../Dashboard/InPostsCard'
import { toastError, toastSuccess } from 'utils/toastify'
import axiosInstance from 'utils/axiosConfig'
import BatchPostAnalysisModal from './BatchAnalysisModal'

const BatchConstOpt = [
   {
      label: 'Select Videos',
      value: 1
   },
   {
      label: 'Status',
      value: 2
   }
]

function PostsReels() {
   const instagramDashboardData = useSelector((state) => state.instagramDashboard)
   const {
      postList,
      loading,
      isNextPage,
      isAllPostGet,
      totalPostsCount,
      selectedVideoIds,
      isBatchAnalysisStatus,
      allPostData: allPostListArray,
      pageNumber
   } = instagramDashboardData

   const authData = useSelector((state) => state.user)
   const { userData } = authData
   const [toggleName, setToggleName] = useState('Posts')
   const [page, setPage] = useState(1)
   const [sortOpenFilter, setSortOpenFilter] = useState(false)
   const [sortType, setSortType] = useState({ label: 'All', or_type: '' })
   const [isEmpty, setIsEmpty] = useState(false)
   const dispatch = useDispatch()
   const [allPostData, setAllPostData] = useState([])
   const [loadingAnalysis, setLoadingAnalysis] = useState(false)
   const [openBatch, setOpenBatch] = useState(false)
   const batchRef = useOutsideClick(() => setOpenBatch(false))
   const [showBatchAnalysisModal, setShowBatchAnalysisModal] = useState(false)
   const onCloseBatchAnalysisModal = () => setShowBatchAnalysisModal(false)
   const [selectedBatchType, setSelectedBatchType] = useState(null)

   useEffect(() => {
      if (pageNumber) {
         setPage(pageNumber)
      }

      return () => {}
   }, [pageNumber])

   useEffect(() => {
      if (isAllPostGet) {
         setPage(1)
         setAllPostData([])
         setSortType({ label: 'All', or_type: '' })
         dispatch(resetFetchAllPostStatus())
      }
      return () => {}
   }, [isAllPostGet])

   const getAllPosts = (page_no, sort) => {
      dispatch(
         getPostListAction({
            page: page_no || pageNumber || 1,
            sort_by: sort !== 'All' ? sort : ''
            // type: 'VIDEO' //VIDEO
         })
      )
      dispatch(setInstagramPageNumberAction(page_no || 1))
   }

   useEffect(() => {
      if (allPostListArray?.length === 0) {
         getAllPosts(1, '')
      }
      return () => {
         // dispatch(resetTotalPostsCount())
      }
   }, [])

   const OnChangeToggle = (name) => {
      setToggleName(name)
      // setPage(1)
   }

   const onChangeSortType = (type, o_type) => {
      setSortType({ label: type, or_type: o_type })
      getAllPosts(1, type)
      setSortOpenFilter(false)
      setIsEmpty(true)
      setAllPostData([])
      dispatch(resetTotalPostsCount())
      dispatch(setInstagramPageNumberAction(1))
   }
   const clearFilter = () => {
      setSortType({ label: 'All', or_type: '' })
      getAllPosts(1, '')
      setIsEmpty(true)
      dispatch(resetTotalPostsCount())
      dispatch(setInstagramPageNumberAction(1))
   }

   // useEffect(() => {
   //    if (postList && postList?.length && !loading) {
   //       if (allPostData?.length > 0) {
   //          setAllPostData((prevItems) => {
   //             const existingIds = new Set(prevItems.map((item) => item.id))
   //             const newUniquePosts = postList.filter((item) => !existingIds.has(item.id))
   //             return [...prevItems, ...newUniquePosts]
   //          })
   //       } else {
   //          setAllPostData(postList)
   //       }
   //    }
   //    return () => {}
   // }, [postList])

   const videoDataRef = useRef(allPostListArray)

   useEffect(() => {
      videoDataRef.current = allPostListArray
   }, [allPostListArray])

   useEffect(() => {
      if (Array.isArray(postList) && postList.length && !loading) {
         const newItems = postList.filter(
            (newItem) => !videoDataRef.current.some((item) => item.id === newItem.id)
         )

         if (newItems.length) {
            const updatedData = [...videoDataRef.current, ...newItems]
            videoDataRef.current = updatedData
            dispatch(setAllPostDataAction(updatedData))
         }
      }
   }, [postList])

   const onLoadMoreData = () => {
      setPage(1 + page)
      getAllPosts(1 + page, sortType.label)
   }

   const handleBatchVideoAnalysis = async () => {
      if (selectedVideoIds.length === 0) return

      try {
         setLoadingAnalysis(true)
         const videoIdsParam = selectedVideoIds.join(',')
         const response = await axiosInstance.get('/instagram/batch_post_analysis', {
            params: {
               post_ids: videoIdsParam
            }
         })
         console.log('batch_video_analysis====', response?.data?.data)
         // update allPostListArray
         let video_id_list = response?.data?.data?.post_ids || []

         if (
            Array.isArray(allPostListArray) &&
            allPostListArray.length > 0 &&
            video_id_list.length > 0
         ) {
            const result = allPostListArray.map((video) =>
               video_id_list.includes(video.id)
                  ? {
                       ...video,
                       status: videStatusConst.processing
                    }
                  : video
            )

            dispatch(setAllPostDataAction(result))
         }
         toastSuccess(response?.data?.message)
      } catch (error) {
         toastError(errorMessage)
         console.error('Error during batch analysis:', error)
      } finally {
         setLoadingAnalysis(false)
         dispatch(clearInstagramAllSelections())
         dispatch(setInstagramBatchAnalysisStatus(false))
      }
      // dispatch(clearInstagramAllSelections())
      // dispatch(setInstagramBatchAnalysisStatus(false))
   }

   const onFetchAllPost = () => {
      dispatch(resetTotalPostsCount())
      dispatch(setInstagramPageNumberAction(1))
      dispatch(
         getPostListAction({
            fetch: 'all'
         })
      )
   }

   return (
      <div className="video-new-layout-wrap instagram-video-section">
         {loading && <Loader />}
         <div className="video-filter-section instagram">
            <div className="card z-2">
               <div className="title-section">
                  <div>
                     <h3 className="at-text-dark">{userData?.username}</h3>
                     <span>{totalPostsCount} ITEMS</span>
                  </div>
                  <div className="instagarm-menu manu-list-section">
                     <div
                        className={`manu-name-section ${toggleName === 'Posts' ? 'active' : ''}`}
                        onClick={() => {
                           OnChangeToggle('Posts')
                        }}>
                        Posts
                     </div>
                     <div
                        className={`manu-name-section ${toggleName === 'Reels' ? 'active' : ''}`}
                        onClick={() => {
                           OnChangeToggle('Reels')
                        }}>
                        Reels
                     </div>
                  </div>
               </div>
               <div className="in-filter-section filter-section mt-3">
                  <div className="filter-wrap">
                     <div className="channel-btn" onClick={onFetchAllPost}>
                        <span>Fetch All</span>
                     </div>
                     {selectedVideoIds?.length > 0 ? (
                        <>
                           <div className="channel-btn" onClick={handleBatchVideoAnalysis}>
                              {loadingAnalysis ? (
                                 <span>
                                    <span className="loader-btn"></span> Saving...
                                 </span>
                              ) : (
                                 <span>Start Batch Analysis ({selectedVideoIds.length})</span>
                              )}
                           </div>
                        </>
                     ) : null}
                     {isBatchAnalysisStatus && (
                        <div
                           className="channel-btn"
                           onClick={() => {
                              dispatch(clearInstagramAllSelections())
                              dispatch(setInstagramBatchAnalysisStatus(false))
                           }}>
                           <span>Reset</span>
                        </div>
                     )}
                     <div className="comment-filter-section">
                        <div className="at-dropdown-filer-wrap" ref={batchRef}>
                           <div
                              className="at-dropdown-filer"
                              onClick={() => {
                                 setOpenBatch(!openBatch)
                              }}>
                              <span className="text-capitalize">Batch Analysis</span>
                              {openBatch ? <UpArrowIcon /> : <DownArrow />}
                           </div>
                           {openBatch && (
                              <ul className="at-list-opt">
                                 {BatchConstOpt &&
                                    BatchConstOpt?.map((item, i) => {
                                       return (
                                          <li
                                             onClick={() => {
                                                if (item.value === 1) {
                                                   if (selectedVideoIds?.length === 0) {
                                                      dispatch(
                                                         setInstagramBatchAnalysisStatus(
                                                            !isBatchAnalysisStatus
                                                         )
                                                      )
                                                   }
                                                }
                                                if (item.value === 2) {
                                                   setShowBatchAnalysisModal(true)
                                                }
                                                setSelectedBatchType(item.value)
                                                setOpenBatch(false)
                                             }}>
                                             <div className="at-list-wrap" key={i}>
                                                {/* {item.value === 1 && selectedVideoIds?.length > 0 ? (
                                                               <div
                                                                  className=""
                                                                  onClick={handleBatchVideoAnalysis}>
                                                                  {loadingAnalysis ? (
                                                                     <span>
                                                                        <span className="loader-btn"></span>{' '}
                                                                        Saving...
                                                                     </span>
                                                                  ) : (
                                                                     <span>
                                                                        Save Analysis ({selectedVideoIds.length})
                                                                     </span>
                                                                  )}
                                                               </div>
                                                            ) : (
                                                               <span className="at-opt-name">{item?.label}</span>
                                                            )} */}
                                                <span className="at-opt-name">{item?.label}</span>
                                             </div>
                                          </li>
                                       )
                                    })}
                              </ul>
                           )}
                        </div>
                     </div>
                     <VideoListSortFilter
                        setSortOpenFilter={setSortOpenFilter}
                        sortOpenFilter={sortOpenFilter}
                        onChangeSortType={onChangeSortType}
                        sortType={sortType}
                     />
                     {sortType.label !== 'All' && (
                        <div
                           className="owner-logo-section add-border videos-filter-icon"
                           onClick={clearFilter}
                           title="Clear Filter">
                           <FilterClearIcon />
                        </div>
                     )}
                  </div>
               </div>
            </div>
         </div>
         <div className="video-wrap mt-5">
            <div className="row">
               {allPostListArray &&
                  allPostListArray?.length > 0 &&
                  allPostListArray
                     ?.filter((item) =>
                        toggleName === 'Posts' ? true : item?.media_type === instagramPostType.VIDEO
                     )
                     .map((item, i) => (
                        <div className="col-12 col-lg-4 mt-3" key={i}>
                           <PostCard items={item} type={toggleName} />
                        </div>
                     ))}
            </div>
         </div>
         {isNextPage ? (
            <div className="load-more mt-4">
               <div
                  className="atenya-ai-btn"
                  onClick={() => {
                     onLoadMoreData()
                  }}>
                  <span>Load More</span>
               </div>
            </div>
         ) : (
            <div className="load-more mt-4">
               <div
                  className="atenya-ai-btn"
                  onClick={() => {
                     dispatch(
                        getPostListAction({
                           fetch: 'all'
                        })
                     )
                  }}>
                  <span>Fetch More</span>
               </div>
            </div>
         )}
         {showBatchAnalysisModal && (
            <BatchPostAnalysisModal
               isOpenNewVideoModal={showBatchAnalysisModal}
               onClose={onCloseBatchAnalysisModal}
            />
         )}
      </div>
   )
}

export default PostsReels

const VideoListSortFilter = ({ setSortOpenFilter, sortOpenFilter, onChangeSortType, sortType }) => {
   const sortTypeRef = useOutsideClick(() => setSortOpenFilter(false))

   return (
      <div className="at-dropdown-filer-wrap at-sort" ref={sortTypeRef}>
         <div
            className="owner-logo-section add-border videos-filter-icon"
            onClick={() => {
               setSortOpenFilter(!sortOpenFilter)
            }}
            title="Sort By">
            <ShortIcon />
            {sortType.label !== 'All' && <div className="active-dot"></div>}
         </div>
         {sortOpenFilter && (
            <ul className="at-list-opt">
               <li
                  onClick={() => {
                     onChangeSortType('All', '')
                  }}>
                  <div className="at-list-wrap">
                     <span className="at-opt-name">All</span>
                     <span className={`at-opt-pin ${sortType.label === 'All' ? 'active' : ''}`}>
                        <span className="w-dot"></span>
                     </span>
                  </div>
               </li>

               <SortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Sentiment Score'}
                  value={'sentiment_score'}
               />

               <SortItemLi
                  onChangeSortType={onChangeSortType}
                  sortType={sortType}
                  label={'Published At'}
                  value={'published_at'}
               />
            </ul>
         )}
      </div>
   )
}

const SortItemLi = ({ onChangeSortType, sortType, label, value }) => {
   return (
      <li
         onClick={() => {
            if (sortType.or_type === 'asc') {
               onChangeSortType(value, 'desc')
            } else if (sortType.or_type === 'desc') {
               onChangeSortType(`-${value}`, 'asc')
            } else {
               onChangeSortType(value, 'desc')
            }
         }}>
         <div className="at-list-wrap">
            <span className="at-opt-name">{label}</span>
            <div className="sort-dot-icon">
               {sortType?.label === value || sortType.label === `-${value}` ? (
                  sortType.or_type === 'asc' ? (
                     <DescSortIcon />
                  ) : sortType.or_type === 'desc' ? (
                     <AscSortIcon />
                  ) : (
                     <ShortIcon />
                  )
               ) : (
                  <ShortIcon />
               )}

               <span
                  className={`at-opt-pin ${
                     sortType.label === value || sortType.label === `-${value}` ? 'active' : ''
                  }`}>
                  <span className="w-dot"></span>
               </span>
            </div>
         </div>
      </li>
   )
}
